<ng-template #campaign [alarisCellCtx]="campaignCtx" let-data="data" let-key="key">
	<app-campaign [campaign]="data"></app-campaign>
</ng-template>

<ng-template #campaignSenders [alarisCellCtx]="campaignCtx" let-data="data" let-key="key">
	<div class="campaign-sender">
		<div class="text-truncate">
			{{ (data.setup.channels[0].sender | sender)?.name }}
		</div>
		@if (data.setup.channels.length > 1) {
			<alaris-icon
				[alarisComplexTooltip]="CampaignTemplateTooltipComponent"
				[componentData]="data"
				name="icon-dot-vertical"
			></alaris-icon>
		}
	</div>
</ng-template>

<ng-template #campaignChannel [alarisCellCtx]="campaignCtx" let-data="data" let-key="key">
	{{ (data.setup.channels.length > 1 ? 'campaigns.cascade' : cu.name(data.setup.channels[0].trafficType)) | translate }}
</ng-template>

<ng-template #cost [alarisCellCtx]="campaignCtx" let-data="data" let-key="key">
	<alaris-cost class="cost" [cost]="data.statistics?.cost"></alaris-cost>
</ng-template>

<ng-template #recipients [alarisCellCtx]="campaignCtx" let-data="data" let-key="key">
	<span class="recipients">{{ data.statistics?.contactCount | number }}</span>
</ng-template>

<ng-template #status [alarisCellCtx]="campaignCtx" let-data="data" let-key="key">
	<alaris-tag
		[mode]="campaignUtils.selectStatusColor(data.info.status)"
		[fill]="!data.isScheduled()"
		size="lg"
		class="status w-100"
	>
		{{ 'enums.' + data.info.status | translate }}
	</alaris-tag>
</ng-template>

<ng-template #progress [alarisCellCtx]="campaignCtx" let-data="data" let-key="key">
	<alaris-progress-line
		[alarisComplexTooltip]="CampaignProgressTooltipComponent"
		[componentData]="data"
		[content]="true"
		[percentageComplete]="campaignUtils.calculatePercentage(data)"
		[type]="campaignUtils.selectCampaignProgressColor(data)"
	>
		{{
			campaignUtils.calculatePercentage(data)
				? (campaignUtils.calculatePercentage(data) | number: '1.0-1') + '%'
				: ('gl.notAvailable' | translate)
		}}
	</alaris-progress-line>
</ng-template>

<ng-template #shortUrl [alarisCellCtx]="campaignCtx" let-data="data" let-key="key">
	@let shortLink = data.info.shortLink;
	@if (shortLink) {
		<alaris-link
			(click)="shortenerUtils.navigateToShortener(shortLink)"
			[alarisTooltip]="shortLink.isArchived ? ('urlShortener.urlBeenArchived' | translate) : ''"
			[attr.data-testid]="'shortLink/' + data.id"
			[underline]="false"
			[class.disabled]="shortLink.isArchived"
			class="short-url"
		>
			{{ shortLink.shortUrl }}
		</alaris-link>
	}
</ng-template>

<ng-template #startDate [alarisCellCtx]="campaignCtx" let-data="data" let-key="key">
	{{ (data.info.startDate | dateFormat) ?? ('gl.notAvailable' | translate) }}
</ng-template>

<ng-template #finishedDate [alarisCellCtx]="campaignCtx" let-data="data" let-key="key">
	{{ (data.info.finishedDate | dateFormat) ?? ('gl.notAvailable' | translate) }}
</ng-template>

<ng-template #lastUpdated [alarisCellCtx]="campaignCtx" let-data="data" let-key="key">
	{{ (data.audit?.lastUpdated | dateFormat) ?? ('gl.notAvailable' | translate) }}
</ng-template>
